export default __webpack_public_path__ + "static/media/Bill.82984ed1.png";